import styled from '@emotion/styled'
import { WindowLocation } from '@reach/router'
import React, { ReactNode } from 'react'
import { CategoryKindType } from '../../types/CategoryKind'
import TopicPath, { ITopicPath } from '../atoms/topicPath'
import SectionBtnArea from '../molecules/sectionBtnArea'
import Footer from './footer'
import Header from './header'
import HeaderTop from './headerTop'

const Wrapper = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  line-height: 1.4em;
  font-size: 15.5px;
`
export type PageType = 'index' | 'guide' | 'manage' | 'setting' | 'faq'

type Props = {
  /** window.location */
  location: WindowLocation
  /** パンくずパス */
  paths?: ITopicPath[]
  /** 子要素 */
  children: ReactNode
  /** カテゴリ種別 */
  categoryKind?: CategoryKindType
}

/**
 * ヘルプ用レイアウト
 * @constructor
 */
const Layout = ({ location, paths, children, categoryKind }: Props) => {
  let header

  if (location.pathname === '/help' || location.pathname === '/help/') {
    header = <HeaderTop />
  } else if (location.pathname === '/help/search') {
    header = <Header className="search-head" />
  } else {
    header = <Header />
  }

  let navigation
  if (location.pathname === '/help' || location.pathname === '/help/') {
    navigation = <></>
  } else {
    navigation = <SectionBtnArea categoryKind={categoryKind} />
  }

  return (
    <div>
      {header}
      <noscript>Javascriptが無効なため有効にしてください</noscript>
      <Wrapper>
        {navigation}
        {paths && <TopicPath paths={paths} />}
        <main>{children}</main>
        <Footer />
      </Wrapper>
    </div>
  )
}

export default Layout
